// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bsEC","label":"styles_label__1FCa9"};